module.exports = __webpack_public_path__ + "static/media/card_2x.45823065.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/new-haven/card_2x.jpg
// module id = 867
// module chunks = 27